import { styled, css } from 'styled-components';
import { theme } from '../../constants/theme.mjs';
import { BadgeVariants } from './Badge.types.mjs';
"use strict";
const Badge = styled.div`
  padding: 2px 4px;
  font-size: ${theme.font.size11};
  line-height: 12px;
  border-radius: 4px;
  font-weight: ${theme.fontWeight.medium};

  ${({
  $variant
}) => {
  switch ($variant) {
    case BadgeVariants.lighterGreen:
      return css`
          color: ${theme.colors.seaGreen};
          background: ${theme.colors.tara};
        `;
    case BadgeVariants.lightGreen:
      return css`
          color: #1c6632;
          background: #d7f5e0;
        `;
    case BadgeVariants.green:
      return css`
          color: ${theme.colors.white};
          background: #61d683;
        `;
    case BadgeVariants.lightGrey:
      return css`
          background: #eee;
          color: #8e8e8e;
        `;
    case BadgeVariants.lightBlue:
      return css`
          background: #e5ebf5;
          color: ${theme.colors.smalt};
        `;
    case BadgeVariants.yellow:
      return css`
          background: #fff1d4;
          color: #9e7200;
        `;
    case BadgeVariants.blue:
      return css`
          background: ${theme.colors.dodgerblue};
          color: ${theme.colors.white};
        `;
    case BadgeVariants.lightNavy:
      return css`
          background: #e0e4f1;
          color: #445178;
        `;
    case BadgeVariants.wizardWhite:
      return css`
          background: #e1f3ff;
          color: #006fff;
        `;
    case BadgeVariants.darkBlueMagenta:
      return css`
          color: #512971;
          background: #ecdcf9;
        `;
    case BadgeVariants.syrahSoil:
      return css`
          color: #9f6c17;
          background: #fdedd3;
        `;
    case BadgeVariants.linearCatalinaBlue:
      return css`
          color: #fff;
          background:
            linear-gradient(
              91.94deg,
              rgb(12 31 105 / 0.33) -6.34%,
              rgb(69 109 253 / 0.33) 100%
            ),
            linear-gradient(91.01deg, #03f 17.46%, #5292f6 93.13%);
          font-weight: ${theme.fontWeight.bold};
        `;
    case BadgeVariants.linearSunsetFlame:
      return css`
          color: #fff;
          background: linear-gradient(91deg, #f00 -12.49%, #f7b016 93.08%);
          font-weight: ${theme.fontWeight.bold};
        `;
    case BadgeVariants.rubyRed:
      return css`
          color: #fff;
          background-color: #9e213e;
          font-weight: ${theme.fontWeight.bold};
        `;
    case BadgeVariants.lightAquaBlue:
      return css`
          color: #2e81a4;
          background-color: #ecf9ff;
          font-weight: ${theme.fontWeight.bold};
        `;
    case BadgeVariants.grey:
    default:
      return css`
          background: rgb(73 73 73 / 0.6);
          color: ${theme.colors.white};
        `;
  }
}}
`;
export { Badge };
//# sourceMappingURL=Badge.styles.mjs.map
